<template>
  <CheckboxBase v-model="localValue" v-bind="$attrs" />
</template>
<script setup>
import { computed } from 'vue'
import CheckboxBase from './CheckboxBase.vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  value: {
    type: [Number, String],
    required: true,
  },
})

const localValue = computed({
  get() {
    return props.modelValue.includes(props.value)
  },
  set(value) {
    let updatedValues = [...props.modelValue]
    if (!value) {
      updatedValues.splice(updatedValues.indexOf(props.value), 1)
    } else {
      updatedValues.push(props.value)
    }

    emit('update:modelValue', updatedValues)
  },
})
</script>
